import { isTablet, isMobile } from 'react-device-detect';
import styled from 'styled-components';
import generateRender from 'shared/utils/generateRender';

const windowWidth = window.innerWidth;

const DefaultContainer = styled.div`
  width: ${isTablet ? (windowWidth < 1150 ? 160 : 150) : 180}px;
  position: relative;
  left: ${isTablet ? '10%' : isMobile ? '11%' : '2.8rem'};

  ${({ theme }) => theme.breakpoints.down('md')} {
    left: ${({ withCard }) => (withCard ? 2.5 : 2.5)}rem;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    left: ${({ withCard }) => (withCard ? 3.8 : 3)}rem;
  }

  ${({ theme }) => theme.breakpoints.only('md')} {
    left: ${({ withCard }) => (withCard ? 3.5 : 3)}rem;
  }

  ${({ theme }) =>
    theme.platform('android') &&
    theme.screens.devices(['mobile-browser', 'mobile-standalone']) &&
    `
    left: 9%;
  `}
`;

const TiContainer = styled(DefaultContainer)`
  ${({ theme }) => theme.breakpoints.down('md')} {
    left: ${({ withCard }) => (withCard ? 2.7 : 2.5)}rem;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    left: ${({ withCard }) => (withCard ? 3.5 : 3)}rem;
  }

  ${({ theme }) => theme.breakpoints.only('md')} {
    left: ${({ withCard }) => (withCard ? 3.1 : 3)}rem;
  }
`;

const SgaContainer = styled(DefaultContainer)`
  ${({ theme }) =>
    theme.platform('android') &&
    theme.screens.devices(['mobile-browser', 'mobile-standalone']) &&
    `
    width: 12.5vw;
    left: 2.8vw;
  `}
  ${({ theme }) =>
    theme.platform('android') &&
    theme.screens.devices(['tablet-browser', 'tablet-standalone']) &&
    `
    width: 10vw;
    left: 4.5vw;
  `}
  ${({ theme }) =>
    theme.platform('ios') &&
    `
    left: 3.5vw;
  `}
`;

const HriContainer = styled(DefaultContainer)`
  ${({ theme }) => theme.breakpoints.down('md')} {
    left: ${({ withCard }) => (withCard ? 2.9 : 2.5)}rem;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    left: ${({ withCard }) => (withCard ? 3.8 : 3)}rem;
  }

  ${({ theme }) => theme.breakpoints.only('md')} {
    left: ${({ withCard }) => (withCard ? 3.5 : 3)}rem;
  }
  ${({ theme }) =>
    theme.platform('android') &&
    theme.screens.devices(['mobile-browser', 'mobile-standalone']) &&
    `
    width: 10.5vw;
    left: 4vw;
  `}
  ${({ theme }) =>
    theme.platform('android') &&
    theme.screens.devices(['tablet-browser', 'tablet-standalone']) &&
    `
    width: 10vw;
    left: 3.5vw;
  `}
  ${({ theme }) =>
    theme.platform('ios') &&
    `
    left: 4.5vw;
  `}
`;

const JamulContainer = styled(DefaultContainer)`
  left: ${isTablet ? '10%' : isMobile ? '11%' : '2.8rem'};

  ${({ theme }) => theme.breakpoints.down('md')} {
    left: ${({ withCard }) => (withCard ? 2.9 : 2.5)}rem;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    left: ${({ withCard }) => (withCard ? 4 : 3)}rem;
  }

  ${({ theme }) =>
    theme.platform('android') &&
    theme.screens.devices(['mobile-browser', 'mobile-standalone']) &&
    `
    width: 10.5vw;
    left: 3.5vw;
  `}
  ${({ theme }) =>
    theme.platform('android') &&
    theme.screens.devices(['tablet-browser', 'tablet-standalone']) &&
    `
    width: 10vw;
    left: 3vw;
  `}
  ${({ theme }) =>
    theme.platform('ios') &&
    `
    left: 3.5vw;
  `}
`;

const MillelacsContainer = styled(DefaultContainer)`
  left: ${isTablet ? '10%' : isMobile ? '11%' : '2.8rem'};
  ${({ theme }) => theme.breakpoints.down('md')} {
    left: ${({ withCard }) => (withCard ? 3 : 2.5)}rem;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    left: ${({ withCard }) => (withCard ? 4.3 : 3)}rem;
  }

  ${({ theme }) => theme.breakpoints.only('md')} {
    left: ${({ withCard }) => (withCard ? 4 : 3)}rem;
  }
`;

const LadyLuckContainer = styled(DefaultContainer)`
  width: ${isTablet ? (windowWidth < 1150 ? 160 : 150) : 170}px;
  left: ${isTablet ? '3rem' : isMobile ? '10%' : '2.8rem'};
  ${({ theme }) => theme.breakpoints.down('md')} {
    left: ${({ withCard }) => (withCard ? 2.8 : 2.5)}rem;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    left: ${({ withCard }) => (withCard ? 4.8 : 4)}rem;
  }

  ${({ theme }) => theme.breakpoints.only('md')} {
    left: ${({ withCard }) => (withCard ? 3.6 : 3)}rem;
  }

  ${({ theme }) => theme.breakpoints.up('xl') || theme.breakpoints.only('xl')} {
    left: ${({ withCard }) => (withCard ? 5 : 3)}rem;
  }

  ${({ theme }) => theme.breakpoints.up('xxl') || theme.breakpoints.only('xxl')} {
    left: ${({ withCard }) => (withCard ? 5.5 : 3)}rem;
  }

  ${({ theme }) =>
    theme.platform('android') &&
    theme.screens.devices(['tablet-browser', 'tablet-standalone']) &&
    `
    width: 10vw;
    left: 2.5vw;
  `}

  ${({ theme }) =>
    theme.platform('ios') &&
    theme.screens.devices(['tablet-browser', 'tablet-standalone']) &&
    `
    left: 4.5vw;
  `}
`;

const Container = generateRender({
  default: DefaultContainer,
  jamul: JamulContainer,
  millelacs: MillelacsContainer,
  hri: HriContainer,
  ladyluck: LadyLuckContainer,
  sga: SgaContainer,
  ti: TiContainer,
});

const ProgressBarTimerTextIconWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  width: 100%;
  height: 2.9rem;
  bottom: 0;
  ${({ theme }) => theme.screens.devices(['tablet-browser', 'tablet-standalone']) && 'height: 3.05rem;'}
  ${({ theme }) => theme.MissionsProgress.ProgressBarTimerTextIconWrapper}
`;

const TimerContainer = styled.div`
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  height: 4rem;
  width: 100%;
  top: 1rem;
  z-index: -1;
`;

const TimeBar = styled.img`
  height: 100%;
  width: 100%;
  position: absolute;
  object-fit: contain;
`;

const TimerIcon = styled.img`
  height: 20px;
  width: 20px;
  object-fit: contain;
`;

const TextProgress = styled.p`
  ${({ theme }) => theme}
  z-index: 5;
  color: white;
  font-weight: 700;
  font-size: 30px;
  text-shadow: 0 0px 3px #000;
`;

const RankContainer = styled.div`
  ${({ theme, isLoyaltyCardLinkVisible }) => isLoyaltyCardLinkVisible ? theme.MissionsProgress.RankContainer : theme.MissionsProgress.RankContainerWithNoCard}
  z-index: 100;
  position: absolute;
  justify-content: center;
`;

const CollectBarContainerStyle = {
  background: '#008400',
  boxShadow: 'inset -3px 0px 3px rgba(0, 0, 0, 0.1), inset -3px -3px 3px rgba(0, 0, 0, 0.3)',
  cursor: 'pointer',
};

const CollectBarFillStyle = {
  background: '#00b600',
  height: '1.8rem',
  boxShadow: '0px 0px 2px #FFFFFF',
};

const ProgressBarRankText = styled.h1`
  position: relative;
  display: inline;
  font-weight: 900;
  font-size: ${({ size }) => size || '4vw'};
  letter-spacing: -1.5px;
  margin-bottom: 0;

  span {
    position: relative;
    background: linear-gradient(0deg, #e7c377 0%, #e7c377 35%, #a1743d 50%, #fef7b9 51%, #e7c377 75%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    -webkit-text-stroke: 1px #ffff8d;
    filter: saturate(160%);
  }

  &::before {
    content: attr(data-text);
    position: absolute;
    top: 1px;
    left: -1.3px;
    z-index: -1;
    -webkit-text-stroke: 3px #400805;
    text-shadow: 0px 3px 2px #c7826a;
    opacity: 1;
  }

  &::after {
    content: attr(data-text);
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    color: rgba(0, 0, 0, 1);
    text-shadow: 5px 10px 15px rgba(0, 0, 0, 1);
    -webkit-text-stroke: 1.5px #ffff8d;
  }

  &::after {
    color: transparent;
  }

  ${({ theme }) => theme.MissionsProgress.ProgressBarRankText}
`;

export {
  Container,
  TimeBar,
  TextProgress,
  CollectBarContainerStyle,
  CollectBarFillStyle,
  TimerContainer,
  ProgressBarTimerTextIconWrapper,
  ProgressBarRankText,
  TimerIcon,
  RankContainer,
};

